export default [
  {
    path: '/proprietario',
    name: 'proprietario',
    component: () => import('@/app-modulo/comuns/proprietario/Proprietario.vue'),
    meta: {
      resource: 'proprietario',
      action: 'create',
      pageTitle: 'Proprietários',
      breadcrumb: [],
    },
  },
]
